module.exports = __webpack_public_path__ + "img/banner2.638d4ba0.png";